export default function(cents) {
    return Number(cents) / 100;
}
